import { PrinterOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ORDER_PAYMENT_STATUS } from "constants/order";
import { stations_location } from "constants/order";
import { ORDER_TYPE } from "constants/order";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import OrderService from "services/order";
import { formatPriceNoDecimal } from "helper/common";

const PrintOrderButton = ({ orderId, showText, buttonType, label }) => {
  const { t: translate } = useTranslation();
  const handleGetOrder = async () => {
    const order = await OrderService.getListById({ id: orderId });
    return order;
  };
  const handlePrint = async () => {
    const order = await handleGetOrder();
    const orderType = Object.values(ORDER_TYPE).find(
      (el) => el.value === order?.orderType
    );

    const paymentStatus = Object.values(ORDER_PAYMENT_STATUS).find(
      (el) => el.value === order?.paymentStatus
    );

    const status = Object.values(stations_location).find(
      (el) => el.value === order?.orderStatus
    );
    if (!order) return;
    const html = `
    <html>
      <head>
        <title>${translate("order.info")}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 24px; }
          .print-title { font-size: 20px; font-weight: bold; margin-bottom: 16px; }
          .print-table { border-collapse: collapse; width: 100%; }
          .print-table th, .print-table td { border: 1px solid #eee; padding: 8px; text-align: left; }
          .print-table th { background: #f5f5f5; }
        </style>
      </head>
      <body>
        <div class="print-title">${translate("order.info")}</div>
        <table class="print-table">
          <tr>
            <th>${translate("order.id")}</th>
            <td>${order?.orderId || ""}</td>
          </tr>
          <tr>
            <th>${translate("order.orderName")}</th>
            <td>${order?.orderName || ""}</td>
          </tr>
          <tr>
            <th>${translate("landing.phoneNumber")}</th>
            <td>${order?.phoneNumber || ""}</td>
          </tr>
          <tr>
            <th>${translate("pendingSchedule.fullName")}</th>
            <td>${order?.firstName || ""}</td>
          </tr>
          ${order?.userHomeAddress ? `<tr>
            <th>${translate("cardSchedule.address")}</th>
            <td>${order?.userHomeAddress}</td>
          </tr>` : ""}
          <tr>
            <th>${translate("order.totalAmount")}</th>
            <td>${order?.totalAmount != null ? formatPriceNoDecimal(order.totalAmount) + "đ" : ""}</td>
          </tr>
          <!-- <tr>
            <th>${translate("order.orderType")}</th>
            <td>${translate(orderType?.label) || ""}</td>
          </tr> -->
          <tr>
            <th>${translate("order.paymentStatus")}</th>
            <td>${
              translate(paymentStatus?.label) ||
              translate("orderPaymentStatus.new")
            }</td>
          </tr>
          <tr>
            <th>${translate("order.orderStatus")}</th>
            <td>${
              translate(status?.label) || translate("orderStatus.pending")
            }</td>
          </tr>
          <tr>
            <th>${translate("order.createdAt")}</th>
            <td>${
              order?.createdAt
                ? moment(order.createdAt).format("DD/MM/YYYY HH:mm:ss")
                : ""
            }</td>
          </tr>
        </table>
      </body>
    </html>
  `;
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return (
    <Button
      type={buttonType || "default"}
      icon={<PrinterOutlined className="action-icon print" />}
      className="action-button"
      onClick={handlePrint}
    >
      {showText ? (label || translate("order.print")) : ""}
    </Button>
  );
};

export default PrintOrderButton;
